/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import RequireForAccess from 'react-access';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import { update } from 'permissions/modelMasters';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import ArchiveManufacturerForm from './ArchiveManufacturerForm/ArchiveManufacturerForm';
import ArchiveManufacturerSuccess from './ArchiveManufacturerSuccess/ArchiveManufacturerSuccess';
import ArchiveManufacturerError from './ArchiveManufacturerError/ArchiveManufacturerError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveManufacturer extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const manufacturer: Object = this.props.manufacturer;

    const fields: Array<Object> = [
      {
        name: 'archiveManufacturerForm',
        label: t('general:actions.archive_manufacturer'),
        title: 'Archive Manufacturer',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required|string',
            value: '',
            placeholder: t('general:placeholders.provide_reason'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().archiveManufacturerForm;

        actionDrawerStore.archiveManufacturer(manufacturer.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.archive_manufacturer'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const manufacturer: Object = this.props.manufacturer;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.archive_manufacturer')} />
          <ArchiveManufacturerError
            manufacturer={manufacturer}
            response={actionDrawerStore.response}
          />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.archive_manufacturer')} />
          <ArchiveManufacturerSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <RequireForAccess permissions={update}>
        <div className={styles['action-drawer-form']}>
          <ActionDrawerHeader title={t('general:actions.archive_manufacturer')} />
          <ArchiveManufacturerForm manufacturer={manufacturer} form={this.createForm()} />
        </div>
      </RequireForAccess>
    );
  }
}
